import toDate from "./toDate.js";
const calculateTimeDifference = (date, translation)=>{
    const now = new Date();
    const then = 'string' == typeof date ? toDate(date) : date;
    const millis = Math.abs(now.getTime() - then.getTime());
    if (millis < 60000) return translation.SECONDS_AGO;
    const mins = Math.ceil(millis / 60000);
    if (1 === mins) return translation.A_MINUTE_AGO;
    if (mins < 60) return translation.MINUTES_AGO(mins);
    const hours = Math.ceil(mins / 60);
    if (1 === hours) return translation.AN_HOUR_AGO;
    if (hours < 24) return translation.HOURS_AGO(hours);
    const days = Math.ceil(hours / 24);
    if (1 === days) return translation.A_DAY_AGO;
    if (days < 30) return translation.DAYS_AGO(days);
    const months = Math.ceil(days / 30);
    if (1 === months) return translation.A_MONTH_AGO;
    if (months < 12) return translation.MONTHS_AGO(months);
    const years = Math.ceil(months / 12);
    if (1 === years) return translation.A_YEAR_AGO;
    return translation.YEARS_AGO(years);
};
const date_calculateTimeDifference = calculateTimeDifference;
export default date_calculateTimeDifference;
